<template>
  <div class="task-center pk-account-panel">
    <section class="task-hero">
      <div class="task-copy">
        <span>奖励中心</span>
        <h1>任务中心</h1>
        <p>完成每日签到、打开箱子、箱子战斗和充值补给任务，积累进度即可领取披萨币、小麦及专属福利奖励。</p>
      </div>
      <div class="task-visual">
        <div class="task-glow"></div>
        <img src="/img/pizzaking/columns/tasks.png" alt="" />
        <img src="@/assets/hotpizza/hp-gloves.png" alt="" />
      </div>
    </section>

    <section class="task-summary">
      <article v-for="item in summary" :key="item.label">
        <span>{{ item.label }}</span>
        <strong>{{ item.value }}</strong>
      </article>
    </section>

    <section class="task-daily-gate">
      <div>
        <span>每日 / 每周 / 每月刷新</span>
        <strong>消耗任务将于 {{ dailyResetText }} 后刷新，签到按自然月重新累计</strong>
        <p>打开箱子、箱子战斗每日重置；充值补给每周一刷新；签到次数与累计奖励每月 1 日刷新。</p>
      </div>
      <div class="task-gate-points">
        <span>当周充值一直累计，每日不重置充值累计</span>
        <span>每周一重置当周充值累计与补给奖励领取状态</span>
        <span>每月 1 日重置签到累计与签到奖励领取状态</span>
        <span>所有任务完成奖励仅在可领取时展示</span>
      </div>
    </section>

    <section class="task-cycle-panel">
      <header>
        <div>
          <span>任务进度</span>
          <h2>周期任务</h2>
        </div>
        <div class="cycle-tabs">
          <button
            v-for="item in cycleTabs"
            :key="item.key"
            :class="{ active: activeCycle === item.key }"
            @click="activeCycle = item.key"
          >{{ item.name }}</button>
        </div>
      </header>
      <div class="cycle-grid">
        <article v-for="item in visibleCycleTasks" :key="item.id">
          <span>{{ item.type }}</span>
          <strong>{{ item.title }}</strong>
          <p>{{ item.desc }}</p>
          <em>{{ item.reward }}</em>
        </article>
        <div v-if="!visibleCycleTasks.length" class="cycle-empty">
          <span>暂无周期任务</span>
          <p>本周期暂无任务</p>
        </div>
      </div>
      <p class="cycle-hint">完成任务后即可领取奖励。</p>
    </section>

    <section class="task-panel">
      <header>
        <div>
          <span>任务列表</span>
          <h2>{{ activeTabName }}</h2>
        </div>
        <LrfTabs :active.sync="activeName" :list="tabs" />
      </header>

      <keep-alive v-if="loggedIn">
        <transition name="el-zoom-in-center">
          <Component :is="activeName"></Component>
        </transition>
      </keep-alive>

      <div v-else class="task-auth-card">
        <img src="/img/pizzaking/columns/tasks.png" alt="" />
        <div>
          <span>需要登录</span>
          <strong>登录后查看任务进度</strong>
          <p>任务进度、签到奖励和充值补给都绑定当前账号。登录后即可继续查看。</p>
        </div>
        <button @click="openLogin">登录账号</button>
      </div>
    </section>
  </div>
</template>

<script>
import {
  SignDay,
  BindBoxTask,
  CombatTask,
  PrepaidRecharge,
  NewcomerTask,
  LrfTabs,
} from "./components";
export default {
  components: {
    SignDay,
    BindBoxTask,
    CombatTask,
    PrepaidRecharge,
    NewcomerTask,
    LrfTabs,
  },
  data() {
    return {
      activeName: "NewcomerTask",
      activeCycle: "daily",
      dailyResetText: "--:--:--",
      dailyResetTimer: null,
      summary: [
        { label: "新人任务", value: "新手专属福利" },
        { label: "每日签到", value: "每日到访奖励" },
        { label: "打开箱子任务", value: "开启箱子赢奖励" },
        { label: "对战任务", value: "参与战斗赢奖励" },
        { label: "充值补给", value: "充值福利补给" },
      ],
      tabs: [
        {
          componentName: "NewcomerTask",
          name: "新人任务",
        },
        {
          componentName: "SignDay",
          name: "每日签到",
        },
        {
          componentName: "BindBoxTask",
          name: "打开箱子任务",
        },
        {
          componentName: "CombatTask",
          name: "对战任务",
        },
        {
          componentName: "PrepaidRecharge",
          name: "充值补给",
        },
        
      ],
      cycleTabs: [
        { key: "daily", name: "每日" },
        { key: "weekly", name: "每周" },
        { key: "monthly", name: "每月" },
      ],
      cycleTasks: [],
    };
  },
  computed: {
    loggedIn() {
      return Boolean(this.$store.state.token);
    },
    activeTabName() {
      const item = this.tabs.find((tab) => tab.componentName == this.activeName);
      return item ? item.name : "任务中心";
    },
    visibleCycleTasks() {
      return this.cycleTasks.filter((item) => item.cycle === this.activeCycle);
    },
  },
  mounted() {
    this.loadCycleTasks();
    this.updateDailyReset();
    this.dailyResetTimer = window.setInterval(this.updateDailyReset, 1000);
  },
  beforeDestroy() {
    window.clearInterval(this.dailyResetTimer);
  },
  methods: {
    loadCycleTasks() {
      this.$axios.post("/index/Activity/cycleTaskList", this.$qs.stringify({})).then((res) => {
        const list = res.data && res.data.status == 1 && res.data.data ? res.data.data.list || [] : [];
        this.cycleTasks = list.map((item) => ({
          id: item.id,
          cycle: item.cycle,
          type: item.type_label,
          title: item.title,
          desc: item.description,
          reward: item.reward_text,
        }));
      });
    },
    updateDailyReset() {
      const now = new Date();
      const next = new Date(now);
      next.setHours(24, 0, 0, 0);
      const seconds = Math.max(0, Math.floor((next.getTime() - now.getTime()) / 1000));
      const hours = String(Math.floor(seconds / 3600)).padStart(2, "0");
      const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
      const secs = String(seconds % 60).padStart(2, "0");
      this.dailyResetText = `${hours}:${minutes}:${secs}`;
    },
    openLogin() {
      this.$store.commit("getLogin", true);
    },
  },
};
</script>

<style lang="less" scoped src="./task-center.less"></style>
